import { translations } from '../../../../../../../locales/translations';
import { BookingUserType } from '../../../../../../../types/BookingType';
import { ActivityData } from '../../ActivityData';
import { BuilderDecisionParams } from '../../BuilderDecisionParams';
import { EventMessageBuilder } from '../../EventMessageBuilder';
import { useFormatTranslationWithDate } from '../../MainMessageBuilder/useFormatTranslationWithDate';

export const useDeliveryDeadlineMessageBuilder = (): EventMessageBuilder => {
  const { formatTranslationWithDate } = useFormatTranslationWithDate();

  const supports = ({
    eventResult: { data, userType }
  }: BuilderDecisionParams): boolean => {
    return userType === BookingUserType.SF && data.endDeadline !== undefined;
  };

  const build = ({ endDeadline }: ActivityData): string => {
    return formatTranslationWithDate(
      translations.pages.booking.features.activity
        .convelioDeliveryDeadlineUpdated,
      endDeadline
    );
  };

  return {
    build,
    supports
  };
};
